import { ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { CategoryDto } from '@entities/product/api/productApi';
import type { ShopDto } from '@entities/shop/api/shopApi';
import { SearchField } from '@shared/ui/SearchField';
import { CategoryRail } from '@widgets/CategoryRail/CategoryRail';
import { ButtonLink } from '@shared/ui/Button';
import { CatalogControls, type ChangeMarketFilter } from './CatalogControls';
import { ShopHeader } from './ShopHeader';
import { SectionSkeleton } from '@widgets/PageSkeleton/PageSkeleton';
import styles from './MarketplaceFrame.module.css';

export interface MarketFilters { query: string; category: string; sort: string; min: string; max: string; available: boolean }
export function MarketplaceFrame({ categories, filters, change, count, total, shop, children, categoriesLoading = false, productsLoading = false }: {
  categories: CategoryDto[]; filters: MarketFilters; change: ChangeMarketFilter;
  count: number; total: number; shop?: ShopDto; children: ReactNode; categoriesLoading?: boolean; productsLoading?: boolean;
}) {
  return <div className={styles.market}>
    <SearchField query={filters.query} onChange={value => change('query', value)} placeholder={shop ? `Search ${shop.name}` : 'Search digital products'} label="Search digital products" flush />
    {shop && <ShopHeader shop={shop} />}
    {categoriesLoading ? <SectionSkeleton variant="categories" /> : <CategoryRail categories={categories} value={filters.category} onChange={id => change('category', id)} />}
    <section className={styles.catalog} id="catalog" aria-label="Product results">
      <CatalogControls filters={filters} change={change} count={count} total={total} shopName={shop?.name} loading={productsLoading} />
      {children}
    </section>
    {!shop && <div className={styles.sellerRow}><div><h2>Have something digital to sell?</h2><p>Make it yours. Open your own shop.</p></div><ButtonLink to="/seller">Create your shop <ArrowRight size={16} /></ButtonLink></div>}
    <footer className={styles.footer}><span>Digital products only</span><a href="/privacy.html">Privacy</a><a href="/terms.html">Terms</a><Link to="/orders">Your orders</Link><Link to="/seller">My shop</Link></footer>
  </div>;
}
